import server from './http'

const loginApi = {
     sendSms: (param) => server.post('/public/sendSms', param),
     smsLogin: (param, config) => server.post('/public/smsLogin', param, config),
     accountLogin: (param, config) => server.post('/public/accountLogin', param, config),
     alterPassword: (param) => server.post('/public/alterPassword', param),
     logout: (param) => server.post('/public/logout', param),
}

export default loginApi

